

  $(".carousel-inner").slick({
   arrows: true,
   dots: false,
   infinite: false,
   speed: 500,
   slidesToShow: 4,
   slidesToScroll: 1,
   responsive: [
      {
          breakpoint: 1200,
          settings: {
            slidesToShow: 2.6, // Adjust for medium screens
          }
      },
      {
          breakpoint: 992,
          settings: {
            slidesToShow: 2.1, // Adjust for medium screens
          }
      },
      {
       breakpoint: 768,
       settings: {
        arrows: true,
        dots: false,
        infinite: false,
        slidesToShow: 1,
        slidesToScroll: 1,
       },
      },
   ],
 });

  $(".insta-card-main").slick({
   arrows: true,
   dots: false,
   infinite: true,
   autoplay: true,
   speed: 500,
   slidesToShow: 5.6,
   slidesToScroll: 1,
   responsive: [
      {
          breakpoint: 1200,
          settings: {
            slidesToShow: 2.6, // Adjust for medium screens
          }
      },
      {
          breakpoint: 992,
          settings: {
            slidesToShow: 2.1, // Adjust for medium screens
          }
      },
      {
       breakpoint: 768,
       settings: {
        arrows: true,
        dots: false,
        infinite: false,
        slidesToShow: 1.6,
        slidesToScroll: 1,
       },
      },
   ],
 });



  $(document).ready(function() {
    // Initialize Slick slider
    $('.videos-wrapper').slick({
      slidesToShow: 5,     
      slidesToScroll: 1, 
      autoplay: false,      
      dots: false,      
      arrows: true,        
      infinite: false,      
      speed: 500,           
      draggable: true,      
      responsive: [
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 4.1, // Adjust for medium screens
          }
        },
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 3.1, // Adjust for smaller screens
          }
        },
        {
          breakpoint: 760,
          settings: {
            slidesToShow: 2.1, // Adjust for very small screens
          }
        },
        {
          breakpoint: 500,
          settings: {
            slidesToShow: 1.6, // Adjust for very small screens
          }
        }
      ]
    });

    // Mute all videos by default and show the play button
    $('.videos-wrapper video').each(function() {
      this.muted = true;
      $(this).siblings('.play-button').show();
    });

    // Play video when the play button is clicked
    $('.videos-wrapper .play-button').click(function() {
      var $video = $(this).siblings('video').get(0); // Get the associated video element

      // Pause all other videos and mute them
      $('.videos-wrapper video').each(function() {
        if (this !== $video) {
          this.pause();
          this.muted = true;
          $(this).siblings('.play-button').show(); // Show play button for paused videos
        }
      });

      // Play the clicked video and unmute it
      if ($video.paused) {
        $video.play();
        $video.muted = true; // Unmute the video
        $(this).hide(); // Hide the play button when the video is playing
      }
    });

    // Handle video click to pause
    $('.videos-wrapper video').click(function() {
      var $video = $(this).get(0);
      if (!$video.paused) {
        $video.pause(); // Pause the video
        $(this).siblings('.play-button').show(); // Show the play button when the video is paused
        $video.muted = true; // Mute the video when paused
      }
    });

    // Ensure the play button reappears when the video ends or is paused
    $('.videos-wrapper video').on('pause', function() {
      $(this).siblings('.play-button').show();
    });
  });



  document.addEventListener("DOMContentLoaded", function () {
  const cards = document.querySelectorAll(
    ".collection-sec .collection-list .collection-card"
  );

  if (!("IntersectionObserver" in window) || !cards.length) return;

  const io = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("is-visible");
          io.unobserve(entry.target); // remove if you want repeat animations
        }
      });
    },
    {
      threshold: 0.5, // triggers when 20% of card is visible
    }
  );

  cards.forEach((card) => io.observe(card));
});
